<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span class="ePub-B">FOR ALICE AND ARCHIE<br/>AND PENGUIN AFICIONADOS<br/>EVERYWHERE</span></p>
<p class="IMG"><img alt="" class="img90" src="images/Spy_Penguins_Credits.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?70f86a8d